import { object } from 'prop-types'
import { FormPerUploadFile } from 'files'
import { ICONE } from 'icons'
import { BaseSceltaImmaginiMultiple } from 'images'
import { BaseButtons } from 'inputs'
import { useModal, BaseModal, BaseGridLayout } from 'layout'
import { arricchisciPropOggetto, GRUPPI_MIME_TYPES } from 'utils'
import useRichiestaServer from '../../network/RichiestaServerHook'
import { ENTITA_BASE } from '../EntitaBase'
import BottoneCreaEntita from '../entitaGenerica/components/BottoneCreaEntita'
import { PROP_TYPES_WRAPPER_FORM_MODIFICA } from '../entitaGenerica/components/FormModificaEntita'
import SmartPanel from '../entitaGenerica/components/SmartPanel'
import ListaImmagini from './ListaImmagini'

ListaImmaginiModifica.propTypes = {
  ...PROP_TYPES_WRAPPER_FORM_MODIFICA,
  propsFormUpload: object
}

ListaImmaginiModifica.defaultConfig = {
  path: 'immagini',
  nomeEntita: ENTITA_BASE.ALLEGATO,
  url: 'immagini',
  label: 'Immagini'
}

export default function ListaImmaginiModifica(props) {
  const {
    propsEntita: { valoriInput, pathEntita, nomeEntita },
    propsInterne_PannelloModificaEntita: {
      gestioneModifica: { modificaEntita, eliminaEntita },
      gestionePermessi: { readOnly },
      infoEntitaPrincipale
    },
    propsFormUpload,
    ...restProps
  } = props

  function modificaImmagine(immagineModificata) {
    const { src, ...restImmagineModificata } = immagineModificata
    modificaEntita(
      nomeEntita,
      pathEntita.addUuid(immagineModificata.uuid),
      restImmagineModificata,
      { fondiConValoreAttuale: false }
    )
  }

  function eliminaImmagine(immagineEliminata) {
    eliminaEntita(
      nomeEntita,
      pathEntita.addUuid(immagineEliminata.uuid),
    )
  }

  const { modalRef, openModal, closeModal } = useModal()

  function salvaImmaginiMultiple(fileCaricatiSulServer) {
    if (readOnly || fileCaricatiSulServer.length === 0) {
      closeModal()
      return
    }
    const nuoveImmagini = fileCaricatiSulServer.map(file => ({ 
      ...file,
      titolo: file.filename,
      descrizione: '',
    }))
    // A rigor di logica non sarebbe del tutto corretto inviare una modifica sul path della lista
    // con la nuova lista completa, perché potrebbe andare in conflitto con un'altra operazione
    // sugli elementi preesistenti della lista. La cosa perfettamente corretta sarebbe una sorta
    // di creazione multipla gestita dal backend, ma non sarebbe così facile da implementare
    // Per ora accettiamo che il caricamento multiplo di immagini sia più sensibile ai conflitti
    modificaEntita(
      nomeEntita,
      pathEntita,
      [...valoriInput, ...nuoveImmagini],
      { fondiConValoreAttuale: false }
    )
    closeModal()
  }

  const propsComponentiUpload = {
    useGestioneFile: useRichiestaServer,
    ...propsFormUpload,
    ...arricchisciPropOggetto(propsFormUpload, 'propsFileInput', {
      dimensioneMaxInMegabyte: 10,
      tipiFileAccettati: [GRUPPI_MIME_TYPES.IMMAGINI],
    })
  }

  return (
    <SmartPanel conScatola {...props}>
      <ListaImmagini
        immagini={valoriInput}
        renderBottoneCaricaImmagine={({ onImmagineCaricata }) =>
          <>
            <BaseGridLayout vertical>
              <BottoneCreaEntita
                nomeEntita={nomeEntita}
                path={pathEntita}
                testo='Carica immagine'
                iconaInizio={ICONE.CARICA}
                renderModalCreazione={({ onSubmit }) => (
                  <FormPerUploadFile
                    defaultValues={null}
                    salvaDati={immagine => onSubmit(immagine)}
                    readOnly={readOnly}
                    {...propsComponentiUpload}
                  />
                )}
                propsModalCreazione={{ disabilitaChiusuraCliccandoFuori: true }}
                opzioniCreazione={{ onCreazioneCompletata: onImmagineCaricata }}
              />
              <BaseButtons.CaricaFile
                testo='Carica immagini multiple'
                color='success'
                onClick={openModal}
                {...(readOnly && { disabled: true })}
              />
            </BaseGridLayout>

            <BaseModal
              ref={modalRef}
              fullScreen
              titolo='Carica immagini multiple'
            >
              <BaseSceltaImmaginiMultiple
                onSalva={salvaImmaginiMultiple}
                onAnnulla={closeModal}
                calcolaAltreInfoPerUpload={({ name }) => ({ titolo: name, descrizione: '' })}
                {...propsComponentiUpload}
              />
            </BaseModal>
          </>
        }
        onImmagineModificata={modificaImmagine}
        onImmagineEliminata={eliminaImmagine}
        readOnly={readOnly}
        infoEntitaPrincipale={infoEntitaPrincipale}
        {...restProps}
      />
    </SmartPanel>
  )
}